import React, { createContext, useContext, useState } from "react";

import { orderModes, OrderModesTypes } from "../../utils/modes";
import { deprecated_useGetData } from "../../../../hooks/useGetData";
import { ISample } from "../../../Samples/interface";
import { IContainer } from "../../interface";
import { useFetchTableData } from "hooks/useFetchTableData";

export const OrderReceiveContext = createContext<any>(null);

const mode: OrderModesTypes = orderModes.receive;
export const OrderReceiveContextProvider = ({ children }) => {
    const [selectedSamples, setSelectedSamples] = useState<ISample[]>([]);
    const [selectedInventoryContainers, setSelectedInventoryContainers] = useState<IContainer[]>([]);
    const [selectedSampleContainers, setSelectedSampleContainers] = useState<IContainer[]>([]);

    const { data, isPending, refreshData, handleReload } = useFetchTableData<any>({
        url: `/orders/receive`,
        additionalParams: "&samples=true",
        onUnmount: () => setSelectedSamples([]),
    });

    return (
        <OrderReceiveContext.Provider
            value={{
                selectedSamples,
                setSelectedSamples,
                selectedInventoryContainers,
                setSelectedInventoryContainers,
                mode,
                data,
                refreshData,
                handleReload,
                selectedSampleContainers,
                setSelectedSampleContainers,
                isPending,
            }}
        >
            {children}
        </OrderReceiveContext.Provider>
    );
};

export const useOrderReceive = (): IUseOrderReceive => {
    const {
        selectedSamples,
        setSelectedSamples,
        selectedInventoryContainers,
        setSelectedInventoryContainers,
        mode,
        data,
        refreshData,
        handleReload,
        selectedSampleContainers,
        setSelectedSampleContainers,
        isPending,
    } = useContext(OrderReceiveContext);

    return {
        selectedSamples,
        setSelectedSamples,
        selectedInventoryContainers,
        setSelectedInventoryContainers,
        mode,
        data,
        refreshData,
        handleReload,
        selectedSampleContainers,
        setSelectedSampleContainers,
        isPending,
    };
};

interface IUseOrderReceive {
    selectedSamples: ISample[];
    setSelectedSamples: (arg: ISample[]) => void;
    selectedInventoryContainers: IContainer[];
    setSelectedInventoryContainers: (arg: IContainer[]) => void;
    mode: OrderModesTypes;
    data: any[];
    refreshData: () => void;
    handleReload: Function;
    selectedSampleContainers: IContainer[];
    setSelectedSampleContainers: React.Dispatch<React.SetStateAction<IContainer[]>>;
    isPending: boolean;
}
